import { useState } from "react";
import "./TailedImage.css";
import useImageLightBox from "hooks/Lightbox/useImageLightBox";
export default function ImageViewer({ images }) {
  const [hoveredImage, setHoveredImage] = useState(null);
  const { Imagebox, setData } = useImageLightBox();

  const handleMouseEnter = (src, event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setHoveredImage({
      src,
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    });
  };

  const handleMouseLeave = () => {
    setHoveredImage(null);
  };

  const handleMouseMove = (event) => {
    if (hoveredImage) {
      setHoveredImage((prev) =>
        prev
          ? {
              ...prev,
              x: event.clientX,
              y: event.clientY,
            }
          : null
      );
    }
  };

  return (
    <>
      <div className="tile-image-container">
        <div className="tile-image-content">
          <div className="tile-image-grid">
            {images.map((src, index) => (
              <div
                key={index}
                className="tile-image-image-container"
                onMouseEnter={(e) => handleMouseEnter(src, e)}
                onMouseLeave={handleMouseLeave}
                onMouseMove={handleMouseMove}
              >
                <div className="tile-image-image-wrapper">
                  <img
                    src={src || "/placeholder.svg"}
                    alt={`Image ${index + 1}`}
                    className="tile-image-image"
                    onClick={(data) => {
                      setData(hoveredImage?.src ? hoveredImage.src : src);
                      console.log(data);
                    }}
                  />
                </div>

                {/* Tail indicator */}
                {/* <div className="tile-image-tail" /> */}
              </div>
            ))}
          </div>

          {/* Hover popup */}
          {/* {hoveredImage && (
            <div
              className="tile-image-popup"
              style={{
                left: hoveredImage.x,
                top: hoveredImage.y,
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                className="tile-image-popup-content"
                // style={{ transform: 'scale(1.2)' }}
                onClick={(data) => {
                  setData(hoveredImage.src);
                  console.log(data);
                }}
              >
                <div className="tile-image-popup-image-wrapper">
                  <img
                    src={hoveredImage.src || "/placeholder.svg"}
                    alt="Zoomed image"
                    className={`tile-image-popup-image-end`}
                  />
                </div>
              </div>
            </div>
          )} */}
        </div>
        <Imagebox />
      </div>
    </>
  );
}
